import React from "react";
import PropTypes from "prop-types";

// Material
import { makeStyles } from "@material-ui/core/styles";
import ButtonBase from "@material-ui/core/ButtonBase";

// Config
import useTranslate from "src/hooks/useTranslate";
import styles from "../../config/styles";

// Components
import Text from "../Text";

const useStyles = makeStyles(theme => ({
  optionWrapper: {
    display: "flex",
    justifyContent: "start",
    flexDirection: "row",
    alignItems: "stretch",
    width: "100%",
    marginBottom: theme.spacing(2.25),
    border: styles.values.border,
    borderRadius: 12,
    overflow: "hidden",
    backgroundColor: ({ buttonColor }) => buttonColor,
    borderColor: ({ borderColor }) => borderColor
  },
  iconContainer: {
    backgroundColor: ({ backgroundColor }) => backgroundColor,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "60px"
  },
  userIcon: {
    width: 36
  },
  optionInfo: {
    display: "flex",
    textAlign: "left",
    padding: theme.spacing(2),
    gap: theme.spacing(2)
  },
  heading: {
    marginBottom: theme.spacing(0.75),
    fontWeight: "bold"
  },
  chip: {
    width: "58px"
  }
}));

const optionsText = "createCasePage.userTypeDialog.options";

const UserTypeButton = ({
  userCapacity,
  icon,
  chipImg,
  backgroundColor,
  onSelect,
  buttonColor,
  borderColor
}) => {
  const classes = useStyles({ backgroundColor, buttonColor, borderColor });
  const getText = useTranslate();

  const text =
    getText(`${optionsText}.${userCapacity}.title`) ||
    getText(`${optionsText}.${userCapacity}.description`);

  return (
    <ButtonBase
      key={userCapacity}
      className={classes.optionWrapper}
      onClick={() => onSelect(userCapacity)}
    >
      <div className={classes.iconContainer}>
        <img className={classes.userIcon} src={icon} alt="" />
      </div>
      <div className={classes.optionInfo}>
        <Text className={classes.heading} type="subtitle1Big">
          {text}
        </Text>
        {chipImg && <img src={chipImg} className={classes.chip} alt="" />}
      </div>
    </ButtonBase>
  );
};

UserTypeButton.propTypes = {
  backgroundColor: PropTypes.string,
  chipImg: PropTypes.string,
  icon: PropTypes.string.isRequired,
  onSelect: PropTypes.func.isRequired,
  userCapacity: PropTypes.string.isRequired,
  buttonColor: PropTypes.string,
  borderColor: PropTypes.string
};

UserTypeButton.defaultProps = {
  chipImg: null,
  buttonColor: "",
  backgroundColor: "",
  borderColor: ""
};

export default UserTypeButton;
